






























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import AppModal from "@/components/global/AppModal.vue";
import { GiftCardTier } from "@/models/gift-card-tiers/GiftCardTier";
import GiftCardTiersModule from "@/store/modules/gift-card-tiers";
import { GiftCardTiersPayload } from "@/models/gift-card-tiers/GiftCardTiersPayload";
import { GiftCardTiersState } from "@/models/store/GiftCardTiersState";
import { sortGiftCardTiers } from "@/helpers/functions/gift-card-tiers/sort-gift-card-tiers";
import { v4 as uuidv4 } from "uuid";

const giftCardTiers = namespace(GiftCardTiersModule.name);

@Component({
  name: "GiftCardTiers",
  components: { AppModal }
})

export default class GiftCardTiers extends Vue {
  // ===== Props ===== //
  @Prop(Boolean) private readonly website!: boolean;
  @Prop(Boolean) private readonly callCenter!: boolean;

  // ===== Store ===== //
  @State("giftCardTiers") private readonly giftCardTiers!: GiftCardTiersState;
  @giftCardTiers.Action("submitGiftCardTiers") public submitGiftCardTiers!: (payload: GiftCardTiersPayload) => void

  // ===== Data ===== //
  public deleteTierModal = false;
  public selectedTier: GiftCardTier | null = null;
  public selectedTierIndex: string | null = null;
  public currentTiers: GiftCardTier[] = [];
  public displayAlert = false;

  // ===== Methods ===== //
  public handleCloseAlert(): void {
    this.displayAlert = false;
  }
  public formatCurrency(event: string, tier: GiftCardTier, inputType: string) {
    if (event.length === 1 || event === "NaN") { event = "0" + event; }
    event = parseFloat(event.toString().replace(/[^\d]/g, "").replace(/(\d\d?)$/, ".$1")).toFixed(2);
    inputType === "min" ? tier.min = event : tier.amount = event;
  }
  public handleCreateGiftCardTier(): void {
    const tierPayload: GiftCardTier = {
      id: uuidv4(),
      min: "0.00",
      amount: "0.00"
    };
    this.currentTiers.unshift(tierPayload);
  }
  public handleDeleteTierModal(tier: GiftCardTier): void {
    this.deleteTierModal = true;
    this.selectedTierIndex = tier.id;
    this.selectedTier = tier;
  }
  public async handleDeleteTier(): Promise<void> {
    await this.deleteTier();
    this.handleResetDeleteTierModal();
  }
  public handleResetDeleteTierModal(): void {
    this.selectedTierIndex = null;
    this.selectedTier = null;
    this.deleteTierModal = false;
  }
  public deleteTier() {
    this.currentTiers = this.currentTiers.filter(tier => tier.id !== this.selectedTierIndex);
  }
  public async handleSubmitGiftCardTiers() {
    this.displayAlert = false;
    this.currentTiers = sortGiftCardTiers(this.currentTiers);
    const tiersArr = this.currentTiers.map(tier => tier.min);
    const duplicate = tiersArr.some((item, idx) => tiersArr.indexOf(item) !== idx);
    const payload = {
      ident: this.callCenter ? "global_call_center_gift_card_tiers" : "global_website_gift_card_tiers",
      value: JSON.stringify(this.currentTiers)
    };
    if (duplicate) {
      this.displayAlert = true;
    } else {
      await this.submitGiftCardTiers(payload);
    }
  }

  // ===== Computed ===== //
  get flow(): string {
    return this.callCenter ? "call-center" : "website";
  }
  get validFields(): boolean {
    return this.currentTiers.every(field => field.min !== "0.01" && field.amount !== "0.01");
  }
  get tiersList(): GiftCardTier[] {
    return this.callCenter ? this.giftCardTiers.callCenterTiers : this.giftCardTiers.websiteTiers;
  }

  // ===== Lifecycle Hook ===== //
  private mounted() {
    this.currentTiers = this.tiersList;
  }
}
